import { InformationCardComponent } from './information-card/information-card.component';
import { LocalizationCardComponent } from './localization-card/localization-card.component';
import * as css from './location-information.module.scss';

export const LocationInformationView = (): React.JSX.Element => {
  return (
    <div className={css.details}>
      <InformationCardComponent />
      <LocalizationCardComponent />
    </div>
  );
};
